<template>
  <div id="AlerLogin">
    <v-row class="mt-4" align="center" justify="center">
      <v-col cols="11" md="8">
        <v-alert text color="primary">
          <h3 class="text-h5">Please login or register before proceed</h3>
          <v-divider class="my-4 primary" style="opacity: 0.22"></v-divider>

          <v-row align="center" no-gutters>
            <v-spacer></v-spacer>
            <v-col class="shrink">
              <v-btn color="primary" outlined @click="goto('register')">
                Register
              </v-btn>
            </v-col>
            <v-divider class="mx-4" vertical></v-divider>
            <v-col class="shrink">
              <v-btn color="primary" @click="goto('login')"> Login </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col></v-row
    >
  </div>
</template>

<script>
export default {
  name: "AlerLogin",
  methods: {
    goto(path) {
      this.$router.push(`/${this.$i18n.locale}/${path}`).catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.layout {
  height: 50vh;
}
</style>
